<script lang="ts">
  import DateDivider from './DateDivider.svelte';
  import UnreadDivider from './UnreadDivider.svelte';
  import MessageBubble from './MessageBubble.svelte';
  import EmptyState from './EmptyState.svelte';
  import { isNewDay, messageDateLabel } from './formatting';
  import type { ChatMessage, MessagingUser } from './api';

  export let messages: ChatMessage[];
  export let currentUserId: number;
  export let participantById: (userId: number) => MessagingUser | undefined;
  export let isGroup: boolean = false;
  export let readersByMessage: (messageId: string) => MessagingUser[] = () => [];
  // The message to show the "N unread" divider directly above -- see ConversationPane's
  // unreadDividerId for how this is computed/held fixed.
  export let unreadDividerId: string | null = null;
  export let scrollEl: HTMLElement | undefined = undefined;

  export let onReply: (message: ChatMessage) => void = () => {};
  export let onEdit: (message: ChatMessage) => void = () => {};
  export let onDelete: (message: ChatMessage) => void = () => {};
  export let onReact: (message: ChatMessage, emoji: string) => void = () => {};
  export let onPin: (message: ChatMessage) => void = () => {};
  export let onUnpin: (message: ChatMessage) => void = () => {};
  export let onForward: (message: ChatMessage) => void = () => {};
  export let onJumpTo: (messageId: string) => void = () => {};
</script>

<div class="flex-1 overflow-y-auto px-4 py-3" bind:this={scrollEl}>
  {#if messages.length === 0}
    <EmptyState icon="fa-light fa-hand-wave" description="Say hello to start the conversation." />
  {/if}
  {#each messages as message, i (message.id)}
    {@const mine = message.sender_id === currentUserId}
    {@const newDay = isNewDay(message.created_at, messages[i - 1]?.created_at)}
    {@const groupStart = newDay || messages[i - 1].sender_id !== message.sender_id}
    {@const groupEnd = i === messages.length - 1 || messages[i + 1].sender_id !== message.sender_id || isNewDay(messages[i + 1].created_at, message.created_at)}
    {#if newDay}
      <DateDivider label={messageDateLabel(message.created_at)} />
    {/if}
    {#if message.id === unreadDividerId}
      <UnreadDivider count={messages.length - i} />
    {/if}
    <MessageBubble
      {message}
      {mine}
      {groupStart}
      {groupEnd}
      {isGroup}
      {currentUserId}
      showSenderName={isGroup}
      sender={mine ? undefined : participantById(message.sender_id)}
      readers={mine ? readersByMessage(message.id) : []}
      {onReply}
      {onEdit}
      {onDelete}
      {onReact}
      {onPin}
      {onUnpin}
      {onForward}
      {onJumpTo}
    />
  {/each}
</div>
